import { Alert } from '@mui/material'
import { useSelector } from 'react-redux'
import i18n from '../../lang/idiomas'

const PasswordRequirements = () => {
  const portal = useSelector(state => state.portal)

  return (
    <Alert
      variant='outlined'
      severity='info'>
      {i18n.t('passdebe')}
      <br />
      <br />
      <ul style={{ listStyle: 'inside' }}>
        <li style={{ listStyle: 'inside' }}>
          {i18n.t('passcmin', { count: portal?.portal?.longitud_password || 8 })}
        </li>
        {portal?.portal?.obligar_mayusculas === 'S' ? <li>{i18n.t('passmayu')}</li> : ''}
        {portal?.portal?.obligar_numero === 'S' ? <li>{i18n.t('passnum')}</li> : ''}
        {portal?.portal?.obligar_simbolo === 'S' ? <li>{i18n.t('passcesp')}</li> : ''}
      </ul>
    </Alert>
  )
}

export default PasswordRequirements
